import Crud from '../views/Comando/Crud'

let routes = {
    path: '/comandos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/comandos',
            name: 'list-comandos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Comandos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
